var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlameIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.78722 1.61768C7.98482 1.3354 8.36497 1.2502 8.66413 1.42116L8.66511 1.42172L8.66652 1.42253C8.93828 1.57931 9.19833 1.75817 9.45254 1.94154C9.91242 2.27325 10.5267 2.76211 11.143 3.39145C12.3625 4.63668 13.6667 6.51193 13.6667 8.86342C13.6667 12.0514 11.1465 14.6666 8.00004 14.6666C4.85361 14.6666 2.33337 12.0514 2.33337 8.86342C2.33337 7.33674 3.07246 5.31808 4.52864 3.86191C4.78899 3.60156 5.2111 3.60156 5.47145 3.86191L5.90957 4.30004L7.78722 1.61768ZM8.00004 13.3333C8.96654 13.3333 9.75004 12.439 9.75004 11.3358C9.75004 10.0129 8.60031 9.08094 8.16467 8.7753C8.06497 8.70535 7.93512 8.70535 7.83541 8.7753C7.39977 9.08094 6.25004 10.0129 6.25004 11.3358C6.25004 12.439 7.03354 13.3333 8.00004 13.3333Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlameIcon);
export default __webpack_public_path__ + "static/media/flame-icon.374d58da1cc3d6bad4e40d321cd6725f.svg";
export { ForwardRef as ReactComponent };